import type { DiceType } from "./types";

export const MAX_DICE = 10;

export function notation(selection: readonly DiceType[]): string {
  if (selection.length === 0) return "Wähle Würfel";
  const counts = new Map<DiceType, number>();
  for (const die of selection) counts.set(die, (counts.get(die) ?? 0) + 1);
  return [...counts.entries()].map(([die, count]) => `${count}d${die}`).join(" + ");
}

export function normalizeD100(tens: number, ones: number): number {
  const value = tens * 10 + ones;
  return value === 0 ? 100 : value;
}

export function canAdd(selection: readonly DiceType[]): boolean {
  return selection.length < MAX_DICE;
}

export function total(values: readonly number[]): number {
  return values.reduce((sum, value) => sum + value, 0);
}
